export const LOCALE_PREFIX = 'components.Dialog.components.About.components.Content'
